import type errors from "./catalogs/en/errors.js";

// Exact legacy diagnostics only. Never classify arbitrary agent or terminal content.
export type DiagnosticCode = Exclude<keyof typeof errors, "unknown">;
export const diagnosticCodes: Readonly<Record<string, DiagnosticCode>> = {
  "Installation status is no longer available. The gateway may have restarted; check installed agents and retry.": "agent_install_status_missing",
  "Installation failed. Check the gateway logs for details.": "agent_install_failed",
  "hosted_commerce_disabled": "billing_disabled",
  "telegram_not_configured": "telegram_billing_unavailable",
  "subscription_exists": "subscription_exists",
  "telegram_account_not_linked": "telegram_billing_unlinked",
  "telegram_invoice_failed": "telegram_invoice_failed",
  "stripe_not_configured": "stripe_unavailable",
  "invalid_plan": "invalid_plan",
  "stripe_subscription_exists": "stripe_subscription_exists",
  "stripe_checkout_failed": "stripe_checkout_failed",
  "stripe_subscription_not_found": "stripe_subscription_missing",
  "stripe_subscription_change_failed": "stripe_change_failed",
  "stripe_subscription_change_cancel_failed": "stripe_change_cancel_failed",
  "stripe_schedule_not_found": "stripe_schedule_missing",
  "invalid_auto_renew_state": "auto_renew_invalid",
  "subscription_not_found": "subscription_missing",
  "stripe_auto_renew_failed": "stripe_renew_failed",
  "telegram_subscription_charge_missing": "stars_charge_missing",
  "telegram_account_invalid": "telegram_account_invalid",
  "telegram_auto_renew_failed": "stars_renew_failed",
  "stripe_customer_not_found": "stripe_customer_missing",
  "stripe_portal_failed": "stripe_portal_failed",
  "gateway not connected": "gateway_offline",
  "session not found": "session_not_found",
  "invalid locale": "preferences_invalid_locale",
  "This Telegram account is not linked to a chatcode account yet.": "telegram_account_unlinked",
  "Telegram session expired. Reopen this Mini App from the bot.": "telegram_session_expired",
  "Failed to authorize this Mini App session.": "telegram_authorization_failed",
  "Failed to load plans": "load_plans_failed",
  "Failed to load signed-in devices": "load_devices_failed",
  "Failed to start Stripe checkout": "checkout_failed",
  "Failed to switch Stripe subscription": "subscription_switch_failed",
  "Failed to cancel scheduled plan change": "cancel_change_failed",
  "Failed to update subscription": "subscription_update_failed",
  "Failed to open Stripe billing portal": "billing_portal_failed",
  "Failed to load install command": "load_install_failed",
  "Failed to unlink Telegram": "telegram_unlink_failed",
  "failed to unlink DigitalOcean": "do_unlink_failed",
  "Failed to revoke device session": "revoke_device_failed",
  "Failed to revoke other devices": "revoke_devices_failed",
  "Failed to load servers": "load_servers_failed",
  "Failed to load sessions": "load_sessions_failed",
  "Failed to create session": "create_session_failed",
  "Failed to end session": "end_session_failed",
  "Failed to rename server": "rename_server_failed",
  "Failed to rename session": "rename_session_failed",
  "Failed to create VPS": "create_server_failed",
  "VPS created but id could not be resolved": "created_server_missing",
  "Enter a server name before generating the install command.": "server_name_required",
  "Failed to generate manual install command": "generate_install_failed",
  "Failed to load current DigitalOcean options": "load_do_options_failed",
  "Failed to power on server": "power_on_failed",
  "Failed to power off server": "power_off_failed",
  "Failed to destroy server": "destroy_server_failed",
  "Failed to remove server": "remove_server_failed",
  "Failed to update gateway": "update_gateway_failed",
  "Failed to load server sessions.": "load_telegram_server_failed",
  "Failed to refresh sessions.": "refresh_sessions_failed",
  "Failed to request gateway update.": "request_gateway_update_failed",
  "Failed to create session.": "create_telegram_session_failed",
  "Failed to open Telegram session.": "open_telegram_session_failed",
  "Open this server from the Telegram bot.": "server_telegram_only",
  "This server is unavailable for your Telegram account.": "server_telegram_unavailable",
  "Open terminal in the Telegram bot.": "session_telegram_only",
  "This session is unavailable for your Telegram account.": "session_telegram_unavailable",
  "Failed to load terminal session details.": "load_terminal_details_failed",
  "Clipboard API unavailable": "clipboard_unavailable",
  "Preview unavailable.": "preview_unavailable",
  "File reference cannot be opened.": "file_reference_unavailable",
  "Link cannot be opened.": "link_unavailable",
  "not_found": "not_found",
  "unauthorized": "unauthorized",
  "forbidden": "forbidden",
  "rate limit exceeded": "rate_limited",
  "invalid JSON body": "invalid_request",
  "invalid workdir": "invalid_workdir",
  "session is not open": "session_closed",
  "agent not installed": "agent_unavailable",
  "gateway command timed out": "gateway_timeout",
  "file too large": "file_too_large",
  "file not found": "file_not_found"
};

export function diagnosticCode(value: string): DiagnosticCode | undefined {
  return Object.hasOwn(diagnosticCodes, value) ? diagnosticCodes[value] : undefined;
}
